"use client";

import DeleteBooking from "@/components/shared/delete-booking";
import PageTitle from "@/components/shared/page-title";
import Whatsapp from "@/components/shared/whatsapp";
import { Button } from "@/components/ui/button";
import { TSettings } from "@/types/settings";
import { TUser } from "@/types/user";
import { useRouter } from "next/navigation";
import { useState } from "react";
import User from "./user";
import SDK from "@/lib/sdk";
import security from "@/lib/security";
import {
  sendEmailVerification,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { firebaseAuth } from "@/lib/firebaseClient";

export default function SignupContainer({ settings }: { settings: TSettings }) {
  const router = useRouter();
  const [step, setStep] = useState<"user" | "created">("user");
  const [error, setError] = useState("");

  const signUp = async (newUser: TUser) => {
    setError("");

    const response = await SDK.user.signup({
      ...newUser,
      name: (await security.encrypt(newUser.name)) || "",
      surname: (await security.encrypt(newUser.surname)) || "",
      phone: (await security.encrypt(newUser.phone)) || "",
    });

    if ("success" in response) {
      const { user } = await signInWithEmailAndPassword(
        firebaseAuth,
        newUser?.email || "",
        newUser?.password || ""
      );
      await sendEmailVerification(user);

      setStep("created");
    } else {
      setError(response.errorMessage);
    }
  };

  return (
    <div className="w-full">
      <DeleteBooking />
      <PageTitle title="Crea tu cuenta" />

      <div className="pt-40">
        <Button
          variant={"outline"}
          className="mt-8"
          onClick={() => router.push("/")}
        >
          {"< "} Volver al calendario
        </Button>
      </div>

      {step === "user" ? (
        <div className="border-1 radius-base p-8 mt-16 mb-16 w-full">
          <h2 className="w-full border-b-1 pb-1 mb-6 font-domine text-2xl font-bold mb-16">
            Regístrate ahora y empieza tus clases regulares.
          </h2>
          <User onUserSave={(user: TUser) => signUp(user)} />
          {error !== "" ? (
            <div className="w-full mt-4 pr-2 flex justify-end text-xs text-secondary-text">
              {error}
            </div>
          ) : (
            <></>
          )}
        </div>
      ) : (
        <div className="border-1 radius-base p-8 mt-16 mb-16 w-full text-center">
          Cuenta creada. Por favor, comprueba tu correo electrónico para
          confirmar el registro.
        </div>
      )}

      <div
        className={
          "fixed bottom-3 right-4 rounded-full z-99 animate-[bounce-once_1s_ease-out_3]"
        }
      >
        <Whatsapp />
      </div>
    </div>
  );
}
